import { ColumnHeaderRowType } from "components/atoms/ExpandedRowTable/ExpandedRowTable";
import { DATE_TIME, YEAR_MONTH, OUTLET_CODE, DECLARED_AMOUNT, NETT_AMOUNT, OUTLET, REIMB_AMOUNT, REVIEW, STATUS, TENANT } from "constants/commonTableColumn";

export const REIMB_VERIFICATION_COLUMN_DATA: Array<ColumnHeaderRowType> = [
	DATE_TIME,
	YEAR_MONTH,
	TENANT,
	OUTLET,
	OUTLET_CODE,
	NETT_AMOUNT,
	DECLARED_AMOUNT,
	REIMB_AMOUNT,
	STATUS,
	REVIEW
];

export const REIMB_APPROVAL_COLUMN_DATA: Array<ColumnHeaderRowType> = [
	DATE_TIME,
	YEAR_MONTH,
	TENANT,
	OUTLET,
	OUTLET_CODE,
	NETT_AMOUNT,
	DECLARED_AMOUNT,
	REIMB_AMOUNT,
	{
		title: "Verifier",
		dataIndex: "verifier_status",
		align: "left",
		width: "10%"
	},
	STATUS,
	REVIEW
];
